import { render, staticRenderFns } from "./FriendList.vue?vue&type=template&id=6f7a9742&scoped=true&"
import script from "./FriendList.vue?vue&type=script&lang=js&"
export * from "./FriendList.vue?vue&type=script&lang=js&"
import style0 from "./FriendList.vue?vue&type=style&index=0&id=6f7a9742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7a9742",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})


/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7a9742')) {
      api.createRecord('6f7a9742', component.options)
    } else {
      api.reload('6f7a9742', component.options)
    }
    module.hot.accept("./FriendList.vue?vue&type=template&id=6f7a9742&scoped=true&", function () {
      api.rerender('6f7a9742', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/會員相關/FriendList.vue"
export default component.exports